import { useEffect, useState } from "react";
import "./App.css";
import InfoBox from "./components/InfoBox";
import Table from "./components/Table";
import Map from "./components/Map";
import { sortData, prettyPrintStats } from "./utility";
import LineGraph from "./components/LineGraph";
import "leaflet/dist/leaflet.css";
import numeral from "numeral";

function App() {
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState("worldwide");
  const [countryInfo, setCountryInfo] = useState({});
  const [worldWide, setWorldWide] = useState("Worldwide");
  const [tableData, setTableData] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 34.80746, lng: -40.4796 });
  const [mapZoom, setMapZoom] = useState(3);
  const [mapCountries, setMapCountries] = useState([]);
  const [casesType, setCasesType] = useState("cases");

  useEffect(() => {
    const getData = async () => {
      await fetch("https://disease.sh/v3/covid-19/countries")
        .then((res) => res.json())
        .then((data) => {
          const countries = data.map((item) => ({
            name: item.country,
            // value: item.countryInfo.iso2,
            value: item.country,
          }));
          const sortedData = sortData(data);
          setTableData(sortedData);
          setMapCountries(data);
          setCountries(countries);
        });
    };
    getData();
  }, []);

  useEffect(() => {
    fetch("https://disease.sh/v3/covid-19/all")
      .then((res) => res.json())
      .then((data) => setCountryInfo(data));
  }, []);

  // let world = "";

  const onCountryChange = async (e) => {
    let world = e.target.value;
    // console.log(world);

    const url =
      e.target.value === "worldwide"
        ? "https://disease.sh/v3/covid-19/all"
        : `https://disease.sh/v3/covid-19/countries/${e.target.value}`;
    await fetch(url)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);

        setCountryInfo(data);
        // setCountry(e.target.value);
        setWorldWide(world);
        // console.log(world);
        setMapCenter([data.countryInfo.lat, data.countryInfo.lng]);
        setMapZoom(4);
      });
  };

  return (
    <div className="app flex justify-evenly p-5">
      <div className="app__left ">
        <div className="app__header flex justify-between align-center mb-5">
          <h1>COVID-19 Tracker</h1>
          <form className="app__dropdown">
            <select
              className="select w-40 p-2 cursor-pointer font-semibold border-solid border-2"
              value={country}
              onChange={onCountryChange}
            >
              {/* <option value="worldwide">{worldwide}</option> */}
              <option value={worldWide}>{worldWide}</option>
              {countries.map((country) => (
                <option value={country.value} key={Math.random()}>
                  {country.name}
                </option>
              ))}
            </select>
          </form>
        </div>

        <div className="app__stats flex justify-between">
          <InfoBox
            active={casesType === "cases"}
            onClick={() => setCasesType("cases")}
            title="Coronavirus Cases"
            cases={prettyPrintStats(countryInfo.todayCases)}
            total={numeral(countryInfo.cases).format("0.0a")}
          />
          <InfoBox
            active={casesType === "recovered"}
            isGreen
            onClick={() => setCasesType("recovered")}
            title="Recovered"
            cases={prettyPrintStats(countryInfo.todayRecovered)}
            total={numeral(countryInfo.recovered).format("0.0a")}
          />
          <InfoBox
            active={casesType === "deaths"}
            onClick={() => setCasesType("deaths")}
            title="Deaths"
            cases={prettyPrintStats(countryInfo.todayDeaths)}
            total={numeral(countryInfo.deaths).format("0.0a")}
          />
        </div>
        <Map
          countries={mapCountries}
          casesType={casesType}
          center={mapCenter}
          zoom={mapZoom}
        />
      </div>

      <div className="app__right">
        <main className="shadow-lg py-2 px-4">
          <h3 className="font-extrabold">Live Cases by Country</h3>
          <Table countries={tableData} />
          <h3 className="font-bold mt-6">World Wide new {casesType}</h3>
          <LineGraph casesType={casesType} />
        </main>
      </div>
    </div>
  );
}

export default App;
